<template>
  <header class="free-header relative flex w-full items-center justify-between">
    <div
      v-if="isCentered || $slots.leftAction"
      class="free-header__action flex shrink-0"
    >
      <slot name="leftAction" />
    </div>
    <div class="free-header__content text-text-neutral-primary grow">
      <slot />
    </div>
    <div
      v-if="isCentered || $slots.rightAction"
      class="free-header__action flex shrink-0 justify-end"
    >
      <slot name="rightAction" />
    </div>
  </header>
</template>

<script setup lang="ts">
  defineProps<{
    isCentered?: boolean;
  }>();
</script>

<style scoped>
  .free-header {
    --free-header-action-width-default: var(--free-header-action-width, 3.5rem);
  }
  .free-header__content {
    max-width: calc(100% - var(--free-header-action-width-default));
  }

  .free-header__action {
    width: var(--free-header-action-width-default);
  }
</style>
